import { FC } from "react"
import { useNavigate } from "react-router-dom"
import { CustomersTable } from "@/components/CustomersTable"
import useGetRecentCustomers from "@/hooks/api/use-get-recent-customers"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

interface Props {
  councilId: string
}

export const RecentCustomersRegistered: FC<Props> = ({ councilId }) => {
  const navigate = useNavigate()
  const { data: recentUsers, isLoading } = useGetRecentCustomers(Number(councilId))

  if (isLoading) {
    return (
      <Card className="w-full">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg">Recent Customers Registered for Portal</CardTitle>
          <p className="text-sm text-muted-foreground">Latest customer portal registrations</p>
        </CardHeader>
        <CardContent>
          <div className="text-sm text-muted-foreground">Loading recent customers...</div>
        </CardContent>
      </Card>
    )
  }

  // Map RecentUserDTO to a compatible format for CustomersTable
  const customers = (recentUsers || []).map((user) => ({
    id: user.id?.toString() || "",
    name: user.name || "",
    email: "",
    address: "",
    web: user.platforms?.includes("web") || false,
    ios: user.platforms?.includes("ios") || false,
    android: user.platforms?.includes("android") || false,
    devices: user.deviceNames?.length || 0,
    lastBill: "",
    status: (user.status as "active" | "inactive" | "suspended") || "active",
    joinDate: user.joinedDate ?? "",
  }))

  return (
    <Card className="w-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Recent Customers Registered for Portal</CardTitle>
        <p className="text-sm text-muted-foreground">Latest customer portal registrations</p>
      </CardHeader>
      <CardContent>
        <div className="max-h-96 overflow-auto">
          <CustomersTable
            customers={customers}
            compact
            showRegistrationDate={true}
            onCustomerClick={(customerId: string) =>
              navigate(`/council/${councilId}/customers/${customerId}`)
            }
          />
        </div>
      </CardContent>
    </Card>
  )
}

export default RecentCustomersRegistered
